// combatpro/treasure/useTreasureCatalogue.js
//
// React hook that loads the external Treasure catalogue ONCE and shares it across
// every consumer (fast modal + full page). The load result is memoized at module
// scope so navigation never re-fetches. Fails soft: on error the hook returns the
// empty-but-valid-shaped catalogue the loader produces, with .errors populated, so
// the UI can show a "catalogue unavailable" state instead of crashing. No optional
// chaining, no em dash.

import { useState, useEffect } from 'react';
import { fetchCatalogue } from './treasureCatalogue';

// Absolute base matches how the spell / monster DBs are provisioned in production
// (app.visinvoke.com/data/...). A relative path also resolves on that origin; the
// absolute form keeps it working from the DCC web window too.
var CATALOGUE_BASE = 'https://app.visinvoke.com/data/treasure';

var _promise = null;
function loadOnce() {
  if (!_promise) { _promise = fetchCatalogue(CATALOGUE_BASE); }
  return _promise;
}

export function useTreasureCatalogue() {
  const [state, setState] = useState({ catalogue: null, loading: true, error: null });
  useEffect(function () {
    var alive = true;
    loadOnce().then(function (cat) {
      if (!alive) { return; }
      setState({ catalogue: cat, loading: false, error: (cat && cat.valid) ? null : ((cat && cat.errors && cat.errors[0]) || 'catalogue invalid') });
    }).catch(function (err) {
      if (!alive) { return; }
      setState({ catalogue: null, loading: false, error: (err && err.message) ? err.message : 'load failed' });
    });
    return function () { alive = false; };
  }, []);
  return state;
}
